<template>
  <div class="py-2">
    <b-toast
      variant="secondary"
      id="attivato-abb"
      title="Attivato!"
      static
      no-close-button
      class="text-center mx-auto"
      body-class="text-gray-dark"
    >
      <p class="text-justify mx-auto mb-0">Abbonamento attivato</p>
    </b-toast>
    <h4
      class="text-secondary"
      v-if="user.anagrafica"
    >{{ utente.anagrafica.fullname+", "+utente.tipologia + " "+utente.role}}</h4>
    <h5>Data registrazione: {{utente.data_iscrizione }}</h5>
    <div
      class="col-12 border rounded border-primary p-0 bg-light my-2"
      v-if="user.tipologia === 'professionista'"
    >
      <h5 class="bg-primary text-white px-1 py-2 font-weight-bold">Abbonamento</h5>

      <div
        class="col-12 px-1 py-2 d-flex flex-wrap justify-content-start mx-auto"
        v-if="user.abbonamento"
      >
        <span class="text-capitalize col-4 mr-auto font-weight-bold">{{ user.abbonamento.nome}}</span>
        <span
          class="text-capitalize col-4 mx-auto font-weight-bold"
          v-for="(servizio,ind) in user.servizi_attivi"
          :key="ind"
        >{{ servizio}}</span>

        <span class="text-capitalize col-4 font-weight-bold">{{ user.abbonamento.prezzo}} €</span>
        <span class="text-capitalize col-6 my-2">
          <strong class="bg-primary text-white p-1 mr-1">Data sottoscrizione:</strong>
          <strong>{{ user.abbonamento.sottoscrizione.data_inizio | moment('LLLL')}}</strong>
        </span>
        <span class="text-capitalize col-6 my-2">
          <strong class="bg-primary text-white p-1 mr-1">Data scadenza:</strong>
          <strong>{{ user.abbonamento.sottoscrizione.data_fine | moment('LLLL')}}</strong>
        </span>
      </div>
      <div class="col-12 px-1 py-2" v-else>
        <span>Nessun Abbonamento</span>
      </div>
      <div class="col-12 px-1 py-2">
        <b-button
          class="col"
          variant="secondary"
          @click="showAbbonamenti=!showAbbonamenti"
        >{{showAbbonamenti ? 'Chiudi' : 'Attiva Abbonamento'}}</b-button>
        <b-form @submit.prevent="attiva" v-if="showAbbonamenti" class="mt-3 text-center">
          <b-form-group class="text-left">
            <b-form-radio
              v-for="(abbonamento,ind) in abb"
              :key="ind"
              v-model="form.abbonamento_hash_id"
              name="abbonamenti"
              :value="abbonamento.hashid"
              required
            >{{abbonamento.slug}}</b-form-radio>
          </b-form-group>
          <b-button class="col-5 mx-auto" variant="primary" type="submit">Attiva</b-button>
        </b-form>
      </div>
    </div>
    <div class="col-12 border rounded border-primary p-0 bg-light mt-2">
      <h5 class="bg-primary text-white px-1 py-2 font-weight-bold">Anagrafica</h5>
      <div v-if="user.anagrafica" class="px-1 py-2">
        <span>
          <strong class="text-primary text-capitalize">email</strong>
          {{user.email }}
          <strong
            class="text-capitalize"
          >{{user.verificato? " verificata" : " non verificata"}}</strong>
        </span>
        <br />
        <span v-if="user.dottorfarma">
          <strong class="text-primary text-capitalize">Utente dottorfarma</strong>
        </span>
        <br />
        <div v-for="(data,ind) in user.anagrafica" :key="ind">
          <span v-if="typeof data == 'string' && ind !== 'hashid'">
            <strong class="text-primary text-capitalize">{{ind}}</strong>
            {{ data}}
          </span>
        </div>
      </div>
      <div v-else>L'utente non ha ancora compilato la scheda anagrafica</div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  name: "dettaglio-utente",
  props: ["utente", "abb"],
  data() {
    return {
      form: {
        abbonamento_hash_id: null,
        user_hash_id: null,
        attivo: true,
        data_inizio: null
      },
      showAbbonamenti: false,
      user: null
    };
  },
  methods: {
    attiva() {
      var url = process.env.VUE_APP_VERSION + "admin/abbonamenti-utente";
      this.form.data_inizio = moment().format("YYYY-MM-DD");
      //   this.form.user_hash_id = user.hashid;
      //   console.log(this.form);
      this.$axios
        .post(url, this.form)
        .then(res => {
          console.log(res.data.data);
          this.form = {
            abbonamento_hash_id: null,
            user_hash_id: null,
            attivo: true,
            data_inizio: null
          };
          this.user = res.data.data;
          this.$bvToast.show("attivato-abb");
        })
        .catch(err => {
          this.msg = err;
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    }
  },
  created() {
    // console.log(this.utente);
    this.utente.data_iscrizione = moment(this.utente.data_iscrizione).format(
      "LLLL"
    );
    this.user = this.utente;
  },
  mounted() {
    this.form.user_hash_id = this.utente.hashid;
  }
};
</script>